// extracted by mini-css-extract-plugin
export var ResourcePropertiesList = "Properties-module--ResourcePropertiesList--3ZPQ8";
export var Header = "Properties-module--Header--1oieJ";
export var Property = "Properties-module--Property--rSBLU";
export var ObjectProperty = "Properties-module--ObjectProperty--1BoU4";
export var Name = "Properties-module--Name--1yKKU";
export var Description = "Properties-module--Description--N0fLY";
export var ObjectProperties = "Properties-module--ObjectProperties--MzJOE";